/* ==========================================================================
   JOURN-E THEME — theme.js (v4.0)
   All interactions. Vanilla JS, no dependencies, deferred.
   Modules: header, mega nav, mobile menu, reveals, slideshow, board finder,
   compare engine, wheel compare, Range Lab, FAQ search, PDP media + bundle,
   sticky ATC, My Garage, count-up, back-to-top.
   ========================================================================== */

(function () {
  'use strict';

  var S = window.JourneSettings || {};
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================= 1. STICKY HEADER ================= */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ================= 2. MEGA NAV (desktop) ================= */
  document.querySelectorAll('.nav-item[data-has-panel]').forEach(function (item) {
    var trigger = item.querySelector('button.nav-link');
    var closeTimer;
    function open()  { document.querySelectorAll('.nav-item.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); }); item.classList.add('is-open'); trigger && trigger.setAttribute('aria-expanded', 'true'); }
    function close() { item.classList.remove('is-open'); trigger && trigger.setAttribute('aria-expanded', 'false'); }

    item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(); });
    item.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 160); });
    if (trigger) {
      trigger.addEventListener('click', function () {
        item.classList.contains('is-open') ? close() : open();
      });
    }
    item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); trigger && trigger.focus(); } });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-item')) {
      document.querySelectorAll('.nav-item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });

  /* ================= 3. MOBILE MENU ================= */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var menuClose  = document.querySelector('.mobile-menu__close');
  var mobileMenu = document.querySelector('.mobile-menu');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
  }
  menuToggle && menuToggle.addEventListener('click', openMobileMenu);
  menuClose && menuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMobileMenu); });
    mobileMenu.querySelectorAll('.mobile-group__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var g = btn.closest('.mobile-group');
        var willOpen = !g.classList.contains('is-open');
        mobileMenu.querySelectorAll('.mobile-group.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        g.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMobileMenu(); });

  /* ================= 4. SCROLL REVEAL ================= */
  var revealEls = document.querySelectorAll('[data-reveal], .reveal-section');
  if (S.animReveal === false || reducedMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-revealed', 'is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.dataset.revealDelay || '0', 10);
          setTimeout(function () { entry.target.classList.add('is-revealed', 'is-visible'); }, delay);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ================= 5. SMOOTH ANCHORS ================= */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.length > 1) {
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          var headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h') || '72', 10);
          var top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
          window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      }
    });
  });

  /* ================= 6. CART COUNT INIT ================= */
  var cartCountEl = document.querySelector('.header__cart-count');
  if (cartCountEl) {
    var count = parseInt(cartCountEl.textContent.trim(), 10);
    cartCountEl.style.display = count > 0 ? 'flex' : 'none';
  }

  /* ================= 7. HERO SLIDESHOW ================= */
  document.querySelectorAll('[data-heroslides]').forEach(function (show) {
    var slides = Array.prototype.slice.call(show.querySelectorAll('.heroslides__slide'));
    if (!slides.length) return;
    var dots = Array.prototype.slice.call(show.querySelectorAll('.heroslides__dot'));
    var idx = 0, timer = null;
    var autoplay = show.dataset.autoplay !== 'false' && slides.length > 1 && !reducedMotion;

    function slideDuration(i) {
      return (parseInt(slides[i].dataset.duration || show.dataset.duration || '7', 10) || 7) * 1000;
    }
    function manageVideos(activeIndex) {
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === activeIndex) { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }
    function go(n, restart) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
      show.style.setProperty('--slide-dur', (slideDuration(idx) / 1000) + 's');
      manageVideos(idx);
      if (restart !== false) schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!autoplay) return;
      timer = setTimeout(function () { go(idx + 1); }, slideDuration(idx));
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var prev = show.querySelector('[data-slide-prev]');
    var next = show.querySelector('[data-slide-next]');
    prev && prev.addEventListener('click', function () { go(idx - 1); });
    next && next.addEventListener('click', function () { go(idx + 1); });

    show.addEventListener('mouseenter', function () { show.classList.add('heroslides--paused'); clearTimeout(timer); });
    show.addEventListener('mouseleave', function () { show.classList.remove('heroslides--paused'); schedule(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? clearTimeout(timer) : schedule(); });

    var touchX = null;
    show.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 48) go(dx < 0 ? idx + 1 : idx - 1);
      touchX = null;
    }, { passive: true });

    go(0);
  });

  /* ================= 8. BOARD FINDER (data-driven) ================= */
  document.querySelectorAll('[data-board-finder]').forEach(function (finder) {
    var cfgEl = finder.querySelector('[data-finder-config]');
    if (!cfgEl) return;
    var boards;
    try { boards = JSON.parse(cfgEl.textContent).boards || []; } catch (e) { return; }
    if (!boards.length) return;

    var resultTitle = finder.querySelector('[data-finder-title]');
    var resultCopy  = finder.querySelector('[data-finder-copy]');
    var resultStats = finder.querySelector('[data-finder-stats]');
    var resultLink  = finder.querySelector('[data-finder-link]');
    var resultImg   = finder.querySelector('[data-finder-image]');
    var resultAlt   = finder.querySelector('[data-finder-alt]');
    var progressEl  = finder.querySelector('[data-finder-progress]');
    var groups = {};

    function tagsOf(btn) {
      return (btn.dataset.tags || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    }
    function score() {
      var selectedTags = [];
      Object.keys(groups).forEach(function (g) { selectedTags = selectedTags.concat(groups[g]); });
      var ranked = boards.map(function (b) {
        var btags = (b.tags || []).map(function (t) { return String(t).toLowerCase(); });
        var s = Number(b.base || 0);
        selectedTags.forEach(function (t) { if (btags.indexOf(t) !== -1) s += 1; });
        return { b: b, s: s };
      }).sort(function (a, c) { return c.s - a.s; });
      return ranked;
    }
    function esc(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
    }
    function render() {
      var ranked = score();
      var top = ranked[0].b;
      var second = ranked[1] ? ranked[1].b : null;
      if (resultTitle) resultTitle.textContent = top.title || '';
      if (resultCopy)  resultCopy.textContent  = top.copy || '';
      if (resultStats) resultStats.innerHTML = (top.stats || []).map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('');
      if (resultLink && top.url) resultLink.setAttribute('href', top.url);
      if (resultImg) {
        if (top.image) { resultImg.src = top.image; resultImg.alt = top.title || ''; resultImg.style.display = ''; }
        else { resultImg.style.display = 'none'; }
      }
      if (resultAlt) {
        resultAlt.innerHTML = second && second.title
          ? 'Also worth a look: <a href="' + esc(second.url || '#') + '">' + esc(second.title) + '</a>'
          : '';
      }
      if (progressEl) {
        var total = finder.querySelectorAll('.finder-question').length;
        var answered = Object.keys(groups).length;
        progressEl.textContent = answered + ' / ' + total + ' answered';
        var bar = finder.querySelector('[data-finder-bar]');
        if (bar) bar.style.width = (total ? Math.round(answered / total * 100) : 0) + '%';
      }
      /* Match strength: winner's score as a share of answered questions */
      var meter = finder.querySelector('[data-finder-meter]');
      var meterLabel = finder.querySelector('[data-finder-meterlabel]');
      if (meter) {
        var answeredCount = Object.keys(groups).length;
        var pct = 0;
        if (answeredCount > 0) {
          pct = Math.max(8, Math.min(100, Math.round((ranked[0].s - Number(top.base || 0)) / answeredCount * 100)));
        }
        meter.style.width = pct + '%';
        meter.classList.toggle('is-strong', pct >= 70);
        if (meterLabel) {
          meterLabel.textContent = answeredCount === 0 ? 'Answer a question to start matching'
            : pct >= 70 ? 'Strong match - ' + pct + '%'
            : pct >= 40 ? 'Good match - ' + pct + '%'
            : 'Early match - keep answering';
        }
      }
      /* Why this board: which of your selected tags it shares */
      var reasonsEl = finder.querySelector('[data-finder-reasons]');
      if (reasonsEl) {
        var picked = [];
        Object.keys(groups).forEach(function (g) { picked = picked.concat(groups[g]); });
        var topTags = (top.tags || []).map(function (t) { return String(t).toLowerCase(); });
        var hits = picked.filter(function (t, i) { return topTags.indexOf(t) !== -1 && picked.indexOf(t) === i; });
        reasonsEl.innerHTML = hits.slice(0, 6).map(function (t) {
          return '<span class="finder-reason">' + esc(t.replace(/-/g, ' ')) + '</span>';
        }).join('');
      }
    }
    finder.querySelectorAll('[data-finder-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.group;
        finder.querySelectorAll('[data-finder-choice][data-group="' + group + '"]').forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        groups[group] = tagsOf(btn);
        render();
      });
    });
    var reset = finder.querySelector('[data-finder-reset]');
    reset && reset.addEventListener('click', function () {
      groups = {};
      finder.querySelectorAll('[data-finder-choice]').forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); });
      render();
    });
    render();
  });

  /* ================= 9. COMPARE ENGINE (boards + wheels) =================
     Container: [data-cmp]
     Column chips: [data-cmp-chip="colKey"] — toggle columns on/off
     Cells: [data-cmp-col="colKey"]
     Row group filters: [data-cmp-filter="group|all"], rows carry data-cmp-group
     Best-in-row: rows with data-cmp-best="max|min" get numeric winner pill  */
  document.querySelectorAll('[data-cmp]').forEach(function (cmp) {
    var maxCols = parseInt(cmp.dataset.cmpMax || '4', 10);
    var chips = Array.prototype.slice.call(cmp.querySelectorAll('[data-cmp-chip]'));
    var active = chips.filter(function (c) { return c.classList.contains('is-on'); }).map(function (c) { return c.dataset.cmpChip; });
    if (!active.length && chips.length) {
      active = chips.slice(0, Math.min(maxCols, chips.length)).map(function (c) { c.classList.add('is-on'); c.setAttribute('aria-pressed', 'true'); return c.dataset.cmpChip; });
    }

    function parseNum(text) {
      var m = String(text).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
      return m ? parseFloat(m[0]) : null;
    }
    function applyBest() {
      cmp.querySelectorAll('tr[data-cmp-best]').forEach(function (row) {
        var mode = row.dataset.cmpBest;
        var cells = Array.prototype.slice.call(row.querySelectorAll('[data-cmp-col]')).filter(function (c) { return !c.classList.contains('cmp__col-hidden'); });
        var best = null, bestVal = null;
        cells.forEach(function (c) {
          c.classList.remove('is-best');
          var pill = c.querySelector('.cmp__best-pill'); if (pill) pill.remove();
          var v = parseNum(c.textContent);
          if (v === null) return;
          if (bestVal === null || (mode === 'min' ? v < bestVal : v > bestVal)) { bestVal = v; best = c; }
        });
        if (best && cells.length > 1) {
          best.classList.add('is-best');
          var pill = document.createElement('span');
          pill.className = 'cmp__best-pill';
          pill.textContent = mode === 'min' ? 'Fastest' : 'Best';
          best.appendChild(pill);
        }
      });
    }
    var scroller = cmp.querySelector('.cmp__scroll');
    function syncOverflow() {
      if (!scroller) return;
      var overflows = scroller.scrollWidth > scroller.clientWidth + 4;
      scroller.classList.toggle('has-overflow', overflows);
      scroller.classList.toggle('at-start', scroller.scrollLeft < 8);
      scroller.classList.toggle('at-end', scroller.scrollLeft + scroller.clientWidth > scroller.scrollWidth - 8);
    }
    if (scroller) {
      scroller.addEventListener('scroll', syncOverflow, { passive: true });
      window.addEventListener('resize', syncOverflow, { passive: true });
    }
    function applyCols() {
      cmp.querySelectorAll('[data-cmp-col]').forEach(function (cell) {
        cell.classList.toggle('cmp__col-hidden', active.indexOf(cell.dataset.cmpCol) === -1);
      });
      cmp.style.setProperty('--cmp-cols', active.length);
      var empty = cmp.querySelector('[data-cmp-empty]');
      if (empty) empty.style.display = active.length ? 'none' : 'block';
      applyBest();
      requestAnimationFrame(syncOverflow);
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.dataset.cmpChip;
        var i = active.indexOf(key);
        if (i !== -1) {
          if (active.length <= 1) return; // keep at least one column
          active.splice(i, 1);
          chip.classList.remove('is-on');
          chip.setAttribute('aria-pressed', 'false');
        } else {
          if (active.length >= maxCols) {
            var dropKey = active.shift();
            var dropChip = chips.filter(function (c) { return c.dataset.cmpChip === dropKey; })[0];
            if (dropChip) { dropChip.classList.remove('is-on'); dropChip.setAttribute('aria-pressed', 'false'); }
          }
          active.push(key);
          chip.classList.add('is-on');
          chip.setAttribute('aria-pressed', 'true');
        }
        applyCols();
      });
    });
    cmp.querySelectorAll('[data-cmp-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        cmp.querySelectorAll('[data-cmp-filter]').forEach(function (b) { b.classList.remove('is-selected', 'is-on'); });
        btn.classList.add('is-selected', 'is-on');
        var val = btn.dataset.cmpFilter;
        cmp.querySelectorAll('tr[data-cmp-group]').forEach(function (row) {
          row.classList.toggle('cmp__row-hidden', val !== 'all' && row.dataset.cmpGroup !== val);
        });
        applyBest();
      });
    });
    applyCols();
  });

  /* ================= 10. WHEEL COMPARE TRAY ================= */
  document.querySelectorAll('[data-wheel-guide]').forEach(function (guide) {
    var bar = guide.querySelector('[data-wheel-bar]');
    var names = guide.querySelector('[data-wheel-bar-names]');
    var goBtn = guide.querySelector('[data-wheel-bar-go]');
    var clearBtn = guide.querySelector('[data-wheel-bar-clear]');
    var cmp = guide.querySelector('[data-cmp]');
    var picked = [];

    function sync() {
      if (names) {
        names.innerHTML = picked.length
          ? 'Comparing: <strong>' + picked.map(function (p) { return p.name; }).join(' · ') + '</strong>'
          : 'Select 2-3 wheels to compare';
      }
      if (bar) bar.classList.toggle('is-visible', picked.length > 0);
      if (goBtn) goBtn.disabled = picked.length < 2;
    }
    guide.querySelectorAll('[data-wheel-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.wheelPick;
        var name = btn.dataset.wheelName || key;
        var i = picked.findIndex(function (p) { return p.key === key; });
        if (i !== -1) { picked.splice(i, 1); btn.classList.remove('is-on'); }
        else {
          if (picked.length >= 3) {
            var dropped = picked.shift();
            var dBtn = guide.querySelector('[data-wheel-pick="' + dropped.key + '"]');
            if (dBtn) dBtn.classList.remove('is-on');
          }
          picked.push({ key: key, name: name });
          btn.classList.add('is-on');
        }
        sync();
      });
    });
    goBtn && goBtn.addEventListener('click', function () {
      if (!cmp) return;
      var chips = cmp.querySelectorAll('[data-cmp-chip]');
      chips.forEach(function (chip) {
        var shouldOn = picked.some(function (p) { return p.key === chip.dataset.cmpChip; });
        var isOn = chip.classList.contains('is-on');
        if (shouldOn !== isOn) chip.click();
      });
      cmp.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
    clearBtn && clearBtn.addEventListener('click', function () {
      picked = [];
      guide.querySelectorAll('[data-wheel-pick].is-on').forEach(function (b) { b.classList.remove('is-on'); });
      sync();
    });
    sync();
  });

  /* ================= 11. RANGE LAB 2.0 (physics engine) =================
     Model (documented):
       Reference condition (how manufacturers rate range): ~70 kg rider,
       smooth flat tar, moderate speed, mild weather, new battery.
       e_ref  (Wh/km)     = battery Wh x 0.95 usable / rated km
       massF  (demand)    = 0.75 x (rider+board)/(70+board) + 0.25
                            - rolling + acceleration energy scale with mass;
                              aero drag does not, hence the 75/25 blend.
       terrainF (demand)  = smooth 1.00 | city 1.20 | rough/hills 1.55
       styleF   (demand)  = chill 1.00 | brisk 1.18 | fast 1.45  (drag ~ v^2)
       tempF  (capacity)  = 1 at 20-32 C; 0.985 at 33 C+;
                            below 20 C: 1 - 0.008 x (20 - T), floor 0.80
       healthF (capacity) = new 1.00 | ~1yr 0.93 | 2yr+ 0.86
       est km = rated x (tempF x healthF) / (massF x terrainF x styleF)
     Shown with a +/-10% band. Clamped to [1, rated].                    */
  document.querySelectorAll('[data-rangelab]').forEach(function (lab) {
    var boards;
    try { boards = JSON.parse(lab.querySelector('[data-rangelab-config]').textContent).boards || []; } catch (e) { return; }
    if (!boards.length) return;

    var TERRAIN = { smooth: 1.0, city: 1.2, rough: 1.55 };
    var STYLE   = { chill: 1.0, brisk: 1.18, fast: 1.45 };
    var HEALTH  = { new: 1.0, year: 0.93, worn: 0.86 };
    var REF_RIDER = 70, USABLE = 0.95;

    var el = function (s) { return lab.querySelector(s); };
    var weightInput = el('[data-rl-weight]');
    var weightOut   = el('[data-rl-weight-out]');
    var tempInput   = el('[data-rl-temp]');
    var tempOut     = el('[data-rl-temp-out]');
    var tripInput   = el('[data-rl-trip]');
    var tripOut     = el('[data-rl-trip-out]');
    var numEl   = el('[data-rl-num]');
    var bandEl  = el('[data-rl-band]');
    var boardEl = el('[data-rl-board]');
    var battEl  = el('[data-rl-batt]');
    var linkEl  = el('[data-rl-link]');
    var whkmEl  = el('[data-rl-whkm]');
    var pctEl   = el('[data-rl-pct]');
    var usableEl = el('[data-rl-usable]');
    var loadWarn = el('[data-rl-loadwarn]');
    var commuteWrap = el('[data-rl-commute]');
    var commuteIcon = el('[data-rl-commute-icon]');
    var commuteText = el('[data-rl-commute-text]');
    var fleetRows = lab.parentElement.querySelector('[data-rl-fleet-rows]');

    var state = { board: 0, terrain: 'smooth', style: 'chill', health: 'new' };
    var shownEst = null;

    function tempFactor(t) {
      if (t >= 33) return 0.985;
      if (t >= 20) return 1;
      return Math.max(0.8, 1 - 0.008 * (20 - t));
    }
    function estimateFor(b, w, t) {
      var rated = Number(b.range) || 1;
      var massF = 0.75 * ((w + Number(b.boardkg || 8)) / (REF_RIDER + Number(b.boardkg || 8))) + 0.25;
      var demand = massF * TERRAIN[state.terrain] * STYLE[state.style];
      var capacity = tempFactor(t) * HEALTH[state.health];
      var est = rated * capacity / demand;
      return Math.min(rated, Math.max(1, est));
    }
    function fillSlider(input) {
      if (!input) return;
      var pct = ((input.value - input.min) / (input.max - input.min)) * 100;
      input.style.setProperty('--fill', pct + '%');
    }
    function animateNum(target) {
      if (!numEl) return;
      if (reducedMotion || shownEst === null) {
        shownEst = target;
        numEl.innerHTML = Math.round(target) + ' <small>KM EST.</small>';
        return;
      }
      var from = shownEst, t0 = null, dur = 450;
      shownEst = target;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        numEl.innerHTML = Math.round(from + (target - from) * eased) + ' <small>KM EST.</small>';
        if (p < 1 && shownEst === target) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function calc() {
      var b = boards[state.board];
      var rated = Number(b.range) || 1;
      var w = Number(weightInput ? weightInput.value : 75);
      var t = Number(tempInput ? tempInput.value : 20);
      var est = estimateFor(b, w, t);
      var usableWh = (Number(b.wh) || 0) * USABLE * tempFactor(t) * HEALTH[state.health];
      var whkm = usableWh && est ? usableWh / est : 0;

      animateNum(est);
      if (bandEl) bandEl.textContent = Math.max(1, Math.round(est * 0.9)) + '-' + Math.round(est * 1.1) + ' km likely band';
      if (boardEl) boardEl.textContent = b.title + ' \u00B7 rated up to ' + rated + ' km';
      if (battEl) battEl.style.width = Math.max(6, Math.min(100, Math.round((est / rated) * 100))) + '%';
      if (linkEl && b.url) linkEl.setAttribute('href', b.url);
      if (whkmEl) whkmEl.textContent = whkm ? whkm.toFixed(1) : '-';
      if (pctEl) pctEl.textContent = Math.round((est / rated) * 100) + '%';
      if (usableEl) usableEl.textContent = usableWh ? Math.round(usableWh) + ' Wh' : '-';
      if (loadWarn) loadWarn.hidden = w <= (Number(b.maxload) || 999);

      if (commuteWrap && tripInput) {
        var trip = Number(tripInput.value) || 0;
        var round = trip * 2;
        var left = est - round;
        var leftPct = Math.round((left / est) * 100);
        commuteWrap.classList.remove('is-ok', 'is-tight', 'is-no');
        if (left >= est * 0.15) {
          commuteWrap.classList.add('is-ok');
          if (commuteText) commuteText.textContent = 'Round trip of ' + round + ' km: easily covered - about ' + leftPct + '% charge to spare.';
        } else if (left >= 0) {
          commuteWrap.classList.add('is-tight');
          if (commuteText) commuteText.textContent = 'Round trip of ' + round + ' km: makes it, but it\u2019s tight (\u2248 ' + Math.max(0, leftPct) + '% left). Plan a top-up charge.';
        } else {
          commuteWrap.classList.add('is-no');
          if (commuteText) commuteText.textContent = 'Round trip of ' + round + ' km: beyond today\u2019s estimate. Charge at your destination, ride gentler, or step up a board.';
        }
      }

      if (fleetRows) {
        var maxEst = 1;
        var all = boards.map(function (bb) {
          var e = estimateFor(bb, w, t);
          if (e > maxEst) maxEst = e;
          return { b: bb, e: e };
        }).sort(function (a, c) { return c.e - a.e; });
        fleetRows.innerHTML = all.map(function (row, i) {
          var isSel = row.b === b;
          return '<a class="rangelab__fleet-row' + (isSel ? ' is-current' : '') + '" href="' + (row.b.url || '#') + '">' +
            '<span class="rangelab__fleet-name">' + String(row.b.title || '').replace(/</g, '&lt;') + '</span>' +
            '<span class="rangelab__fleet-bar"><span style="width:' + Math.round((row.e / maxEst) * 100) + '%"></span></span>' +
            '<span class="rangelab__fleet-km">' + Math.round(row.e) + ' km</span>' +
          '</a>';
        }).join('');
      }
    }

    [weightInput, tempInput, tripInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        if (input === weightInput && weightOut) weightOut.textContent = input.value + ' kg';
        if (input === tempInput && tempOut) tempOut.textContent = input.value + ' \u00B0C';
        if (input === tripInput && tripOut) tripOut.textContent = input.value + ' km';
        fillSlider(input);
        calc();
      });
      fillSlider(input);
    });
    if (weightInput && weightOut) weightOut.textContent = weightInput.value + ' kg';
    if (tempInput && tempOut) tempOut.textContent = tempInput.value + ' \u00B0C';
    if (tripInput && tripOut) tripOut.textContent = tripInput.value + ' km';

    lab.querySelectorAll('[data-rl-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.rlChoice;
        lab.querySelectorAll('[data-rl-choice="' + group + '"]').forEach(function (o) { o.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (group === 'board') state.board = parseInt(btn.dataset.value, 10) || 0;
        else state[group] = btn.dataset.value;
        calc();
      });
    });
    calc();
  });

  /* ================= 12. FAQ: accordion + live search + categories ================= */
  document.querySelectorAll('.faq__list').forEach(function (list) {
    list.querySelectorAll('details').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (detail.open) {
          list.querySelectorAll('details').forEach(function (other) { if (other !== detail) other.open = false; });
        }
      });
    });
  });
  document.querySelectorAll('[data-faq]').forEach(function (faq) {
    var input = faq.querySelector('[data-faq-search]');
    var noRes = faq.querySelector('[data-faq-noresults]');
    var cats = faq.querySelectorAll('[data-faq-cat]');
    var items = Array.prototype.slice.call(faq.querySelectorAll('details[data-faq-item]'));
    var activeCat = 'all';

    items.forEach(function (d) {
      var sum = d.querySelector('summary .faq-q-text') || d.querySelector('summary');
      if (sum) d.dataset.qOriginal = sum.textContent;
    });
    function apply() {
      var q = (input ? input.value : '').trim().toLowerCase();
      var visible = 0;
      items.forEach(function (d) {
        var text = (d.textContent || '').toLowerCase();
        var catOk = activeCat === 'all' || (d.dataset.faqGroup === activeCat);
        var qOk = !q || text.indexOf(q) !== -1;
        var show = catOk && qOk;
        d.style.display = show ? '' : 'none';
        if (show) visible++;
        var sum = d.querySelector('summary .faq-q-text') || d.querySelector('summary');
        if (sum && d.dataset.qOriginal) {
          if (q && show) {
            var orig = d.dataset.qOriginal;
            var idx = orig.toLowerCase().indexOf(q);
            sum.innerHTML = idx !== -1
              ? orig.slice(0, idx) + '<mark>' + orig.slice(idx, idx + q.length) + '</mark>' + orig.slice(idx + q.length)
              : orig;
          } else {
            sum.textContent = d.dataset.qOriginal;
          }
        }
        if (q && show && text.indexOf(q) !== -1) d.open = false;
      });
      faq.querySelectorAll('[data-faq-groupwrap]').forEach(function (wrap) {
        var any = Array.prototype.some.call(wrap.querySelectorAll('details[data-faq-item]'), function (d) { return d.style.display !== 'none'; });
        wrap.style.display = any ? '' : 'none';
      });
      if (noRes) noRes.classList.toggle('is-visible', visible === 0);
    }
    input && input.addEventListener('input', apply);
    cats.forEach(function (btn) {
      btn.addEventListener('click', function () {
        cats.forEach(function (b) { b.classList.remove('is-selected', 'is-on'); });
        btn.classList.add('is-selected', 'is-on');
        activeCat = btn.dataset.faqCat;
        apply();
      });
    });
    apply();
  });

  /* ================= 13. PDP: MEDIA GALLERY ================= */
  document.querySelectorAll('[data-pmedia]').forEach(function (gallery) {
    var items = gallery.querySelectorAll('.pmedia__item');
    var thumbs = gallery.querySelectorAll('.pmedia__thumb');
    function show(id) {
      items.forEach(function (it) {
        var on = it.dataset.mediaId === id;
        it.classList.toggle('is-active', on);
        var v = it.querySelector('video');
        if (v) { on ? v.play().catch(function () {}) : v.pause(); }
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaTarget === id); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.mediaTarget); });
    });
  });

  /* ================= 14. QTY STEPPERS (PDP + cart page) ================= */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var dec = wrap.querySelector('[data-qty-dec]');
    var inc = wrap.querySelector('[data-qty-inc]');
    if (!input) return;
    dec && dec.addEventListener('click', function () {
      input.value = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    inc && inc.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ================= 15. STICKY ADD-TO-CART BAR ================= */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainBuyBox = document.querySelector('[data-buy-anchor]');
  if (stickyBar && mainBuyBox && 'IntersectionObserver' in window) {
    var atcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    atcIO.observe(mainBuyBox);
    var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    stickyBtn && stickyBtn.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]');
      if (form) {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  /* ================= 16. COMPLETE YOUR RIDE (bundle builder) ================= */
  document.querySelectorAll('[data-bundle]').forEach(function (bundle) {
    var totalEl = bundle.querySelector('[data-bundle-total]');
    var countEl = bundle.querySelector('[data-bundle-count]');
    var addBtn = bundle.querySelector('[data-bundle-add]');
    var mainPriceCents = parseInt(bundle.dataset.mainPrice || '0', 10);

    function money(cents) {
      if (window.JourneMoney) return window.JourneMoney(cents);
      return 'R' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function currentVariantId() {
      var idInput = document.querySelector('form[data-product-form] [name="id"]');
      return idInput ? idInput.value : null;
    }
    function recalc() {
      var extras = 0, n = 0;
      bundle.querySelectorAll('[data-bundle-item]:checked').forEach(function (cb) {
        extras += parseInt(cb.dataset.price || '0', 10);
        n++;
      });
      if (totalEl) totalEl.textContent = money(mainPriceCents + extras);
      if (countEl) countEl.textContent = n ? '+ ' + n + ' add-on' + (n > 1 ? 's' : '') : 'Board only';
      if (addBtn) addBtn.textContent = n ? 'Add board + ' + n + ' item' + (n > 1 ? 's' : '') : 'Add board to cart';
    }
    bundle.querySelectorAll('[data-bundle-item]').forEach(function (cb) {
      cb.addEventListener('change', recalc);
    });
    addBtn && addBtn.addEventListener('click', function () {
      var items = [];
      var mainId = currentVariantId();
      if (mainId) items.push({ id: parseInt(mainId, 10), quantity: 1 });
      bundle.querySelectorAll('[data-bundle-item]:checked').forEach(function (cb) {
        items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
      });
      if (!items.length) return;
      var original = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) throw new Error(res.description || 'Could not add');
          addBtn.textContent = 'Added ✓';
          if (window.JourneCart) { window.JourneCart.refresh(); window.JourneCart.open(); }
          setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1600);
        })
        .catch(function (err) {
          console.error(err);
          addBtn.textContent = original;
          addBtn.disabled = false;
          alert('Sorry - one of those items could not be added. Please try again.');
        });
    });
    recalc();
  });

  /* ================= 17. MY GARAGE ================= */
  var GARAGE_KEY = 'journe_garage_board';
  var Garage = {
    get: function () { try { return localStorage.getItem(GARAGE_KEY) || ''; } catch (e) { return ''; } },
    set: function (v) { try { v ? localStorage.setItem(GARAGE_KEY, v) : localStorage.removeItem(GARAGE_KEY); } catch (e) {} Garage.paint(); },
    paint: function () {
      var mine = Garage.get();
      document.querySelectorAll('[data-garage-chip]').forEach(function (chip) {
        var on = chip.dataset.garageChip === mine;
        chip.classList.toggle('is-on', on);
        chip.classList.toggle('is-selected', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-fits]').forEach(function (el) {
        var fits = (el.dataset.fits || '').toLowerCase().split(/[\s,]+/);
        var match = !!mine && fits.indexOf(mine) !== -1;
        if (el.classList.contains('fits-badge') || el.classList.contains('garage-banner')) {
          el.classList.toggle('is-on', match);
        }
        if (el.classList.contains('wheel-card__fit')) {
          el.classList.toggle('is-mine', mine && el.dataset.fits === mine);
        }
      });
      document.querySelectorAll('[data-garage-name]').forEach(function (el) {
        el.textContent = mine ? mine.charAt(0).toUpperCase() + mine.slice(1) : '';
      });
    }
  };
  window.JourneGarage = Garage;
  if (S.garageEnabled !== false) {
    document.querySelectorAll('[data-garage-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = chip.dataset.garageChip;
        Garage.set(Garage.get() === v ? '' : v);
      });
    });
    Garage.paint();
  }

  /* ================= 17b. ROAD SO FAR — scroll-drawn route =================
     [data-route] wraps an SVG path ([data-route-path]) that draws itself as
     the section scrolls through the viewport, plus an HTML rider marker
     ([data-route-rider]) that travels the path. Milestones light up as the
     rider passes them. Static (fully drawn) when reduced motion is on.     */
  document.querySelectorAll('[data-route]').forEach(function (route) {
    var path = route.querySelector('[data-route-path]');
    var rider = route.querySelector('[data-route-rider]');
    var items = Array.prototype.slice.call(route.querySelectorAll('.route__item'));
    if (!path || typeof path.getTotalLength !== 'function') return;
    var len = path.getTotalLength();
    path.style.strokeDasharray = len + ' ' + len;
    if (reducedMotion) {
      path.style.strokeDashoffset = 0;
      items.forEach(function (i) { i.classList.add('is-passed'); });
      if (rider) rider.style.display = 'none';
      return;
    }
    path.style.strokeDashoffset = len;

    var ticking = false;
    function update() {
      ticking = false;
      var rect = route.getBoundingClientRect();
      var vh = window.innerHeight;
      var progress = (vh * 0.72 - rect.top) / rect.height;
      progress = Math.max(0, Math.min(1, progress));
      path.style.strokeDashoffset = len * (1 - progress);

      var pt = path.getPointAtLength(len * progress);
      var ctm = path.getScreenCTM();
      if (!ctm) return;
      var vp = new DOMPoint(pt.x, pt.y).matrixTransform(ctm);
      if (rider) {
        rider.style.transform = 'translate(' + (vp.x - rect.left) + 'px,' + (vp.y - rect.top) + 'px)';
        rider.style.opacity = progress > 0.005 ? 1 : 0;
      }
      items.forEach(function (item) {
        var itemTop = item.getBoundingClientRect().top;
        item.classList.toggle('is-passed', vp.y >= itemTop + 30);
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  });

  /* ================= 17c. AUTH — show/hide password ================= */
  document.querySelectorAll('[data-pw-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.dataset.pwToggle);
      if (!input) return;
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      btn.setAttribute('aria-pressed', show ? 'true' : 'false');
      btn.textContent = show ? 'Hide' : 'Show';
    });
  });

  /* ================= 17d. BOARD SPOTLIGHT — gallery + quick add ================= */
  document.querySelectorAll('[data-spotlight]').forEach(function (spot) {
    var mainImg = spot.querySelector('[data-spotlight-main]');
    spot.querySelectorAll('[data-spotlight-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        spot.querySelectorAll('[data-spotlight-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImg.src = thumb.dataset.src;
        if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
      });
    });
    var form = spot.querySelector('form[data-spotlight-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            if (btn) btn.textContent = 'Added \u2713';
            if (window.JourneCart) { window.JourneCart.refresh(); window.JourneCart.open(); }
            setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1500);
          })
          .catch(function () {
            if (btn) { btn.textContent = original; btn.disabled = false; }
            window.location.href = form.getAttribute('action') || '/cart';
          });
      });
    }
  });

  /* ================= 18. COUNT-UP STATS ================= */
  var counters = document.querySelectorAll('[data-countup]');
  if (counters.length && 'IntersectionObserver' in window && !reducedMotion) {
    var cIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        cIO.unobserve(el);
        var target = parseFloat(el.dataset.countup);
        if (isNaN(target)) return;
        var suffix = el.dataset.countupSuffix || '';
        var dur = 1200, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cIO.observe(el); });
  }

  /* ================= 19. BACK TO TOP ================= */
  var backTop = document.getElementById('BackToTop');
  if (backTop) {
    window.addEventListener('scroll', function () {
      backTop.classList.toggle('is-visible', window.scrollY > 900);
    }, { passive: true });
    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  }

  /* ================= 20. COLLECTION SORT ================= */
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

})();

/* ================= 21. VARIANT SELECT → PRICE SYNC ================= */
(function () {
  'use strict';
  var sel = document.querySelector('[data-variant-select]');
  if (!sel) return;
  function sync() {
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var priceEls = document.querySelectorAll('[data-product-price], [data-product-price-sticky]');
    priceEls.forEach(function (el) { if (opt.dataset.price) el.textContent = opt.dataset.price; });
    var cmpEl = document.querySelector('[data-product-compare]');
    if (cmpEl) {
      if (opt.dataset.compare) { cmpEl.textContent = opt.dataset.compare; cmpEl.style.display = ''; }
      else { cmpEl.style.display = 'none'; }
    }
  }
  sel.addEventListener('change', sync);
  sync();
})();
